import { sizes } from 'style';
import { th } from 'style/theme';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;

  @media ${sizes.desktop} {
    font-size: 16px;
  }
`;
export const Content = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'progress type'
    'price price'
    'progression-bar progression-bar'
    'mobile-buttons mobile-buttons';
  grid-column-gap: 12px;
  padding: 24px;
  border-radius: 32px 32px 0 0;
  background-color: ${th('colors.white')};

  @media ${sizes.tabletLandscape} {
    grid-template-columns: 20% 20% 1fr;
    grid-template-areas:
      'progress type progression-bar progression-bar'
      'price price progression-bar progression-bar';
    padding: 32px 32px 20px 32px;
  }
`;

export const Footer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: 12px;
  grid-template-areas: 'claim-id claimed-by';
  align-items: center;
  border-radius: 0 0 32px 32px;
  padding: 24px;
  background-color: ${th('colors.porsche+4')};

  @media ${sizes.tabletLandscape} {
    padding: 16px 32px 16px 32px;
    grid-template-columns: 20% auto min-content;
    grid-template-areas: 'claim-id claimed-by desktop-buttons desktop-buttons';
  }
`;

export const DesktopButtons = styled.div`
  grid-area: desktop-buttons;
  display: none;
  @media ${sizes.tabletLandscape} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex: 1;
    justify-content: flex-end;
  }
`;

export const MobileButtons = styled.div`
  grid-area: mobile-buttons;
  margin-top: 24px;

  @media ${sizes.tabletLandscape} {
    display: none;
  }
`;

export const Progress = styled.div`
  grid-area: progress;
  font-weight: 700;
`;

export const Price = styled.div`
  font-weight: 500;
  grid-area: price;
  margin-top: 16px;

  @media ${sizes.desktop} {
    margin-top: 16px;
  }
`;

export const ProgressionBar = styled.div`
  grid-area: progression-bar;
`;

export const ClaimType = styled.div`
  grid-area: type;
  font-weight: 500;
`;

export const Label = styled.div``;

export const Text = styled.div`
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ClaimIdWrapper = styled.div`
  grid-area: claim-id;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ClaimedByWrapper = styled.div`
  grid-area: claimed-by;
  justify-self: flex-end;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  @media ${sizes.desktop} {
    justify-self: flex-start;
  }
`;
